export function formotTime (hours, minutes, seconds) {
    return <><span class="t-num">{ hours }</span><span class="t-ut ut-m-r">h</span>
    <span class="t-num">{ minutes }</span><span class="t-ut ut-m-r">m</span>
    <span class="t-num">{ seconds }</span><span class="t-ut">s</span></>
}